import { Paper, Typography } from '@material-ui/core';
import { Col, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import React from 'react';
import { REASON_REFUSAL } from '../../constants/selects';
import useRegisterReasonRefusal from '../../hooks/reasonRefusal/useRegisterReasonRefusal';
import history from '../../services/history';
import ActivityIndicator from '../ActivityIndicator';
import FooterForm from '../FooterForm';
import { makeStyles } from '@material-ui/core/styles';
import validationSchema from './validations';
import { reasonRefusalForm } from '../../services/types';

const useStyles = makeStyles(theme => ({
  container: {
    padding: '1rem',
    marginTop: '2rem',
    borderRadius: '1rem',
  },
  title: {
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '1.25rem',
    color: '#1c2434',
    lineHeight: '2rem',
    fontWeight: 600,
    paddingLeft: '1rem',
  },
  paragraph: {
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: 500,
    color: '#1c2434',
    fontSize: '1rem',
    lineHeight: '1rem',
    textAlign: 'center',
  },
  containerInput: {
    marginTop: '1rem',
  },
}));

const FormReasonRefusal: React.FC = () => {
  const classes = useStyles();
  const { execute, loading } = useRegisterReasonRefusal();

  const submitForm = (values: reasonRefusalForm) => {
    execute(values.reason, values.description, () => {
      history.goBack();
    });
  };

  if (loading) {
    return <ActivityIndicator />;
  }

  return (
    <Paper elevation={3} className={classes.container}>
      <Typography className={classes.title}>Novo motivo de recusa</Typography>
      <hr />
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          reason: '',
          description: '',
        }}
        onSubmit={(values: reasonRefusalForm) => {
          submitForm(values);
        }}
      >
        {({ errors, touched, handleChange, handleSubmit, values }) => (
          <Form onSubmit={handleSubmit}>
            <Col>
              <Form.Label className={classes.paragraph}>Razão *</Form.Label>
              <Form.Control
                id="reason"
                value={values.reason}
                type="text"
                placeholder="Razão"
                className="form-control"
                onChange={handleChange}
              />
              {errors.reason && touched.reason ? (
                <div className="error-message">{errors.reason}</div>
              ) : null}
            </Col>
            <Col className={classes.containerInput}>
              <Form.Label className={classes.paragraph}>Descrição *</Form.Label>
              <Form.Control
                id="description"
                value={values.description}
                type="text"
                placeholder="Descrição"
                className="form-control"
                onChange={handleChange}
              />
              {errors.description && touched.description ? (
                <div className="error-message">{errors.description}</div>
              ) : null}
            </Col>
            <FooterForm id="" />
          </Form>
        )}
      </Formik>
    </Paper>
  );
};

export default FormReasonRefusal;
